import { type HTMLAttributes, type ReactNode } from "react";
import { DataRow, DataRowMain } from "./data-row";
import { cn } from "../../lib/cn";

export interface MetricProps {
  title: string;
  value: string;
  footnote?: string;
  icon?: ReactNode;
  tone?: "success" | "warning" | "info" | "accent";
  className?: string;
}

export interface MetricGroupProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function MetricGroup({ children, className, ...props }: MetricGroupProps) {
  return (
    <section className={cn("ui-metric-group", className)} {...props}>
      {children}
    </section>
  );
}

export function Metric({ title, value, footnote, icon, tone = "info", className }: MetricProps) {
  return (
    <DataRow as="div" interactive={false} className={cn("ui-metric", `ui-metric-tone-${tone}`, className)}>
      <DataRowMain className="ui-metric-main">
        <span className="ui-metric-label">
          <span>{title}</span>
          {icon}
        </span>
        <strong>{value}</strong>
        {footnote ? <small>{footnote}</small> : null}
      </DataRowMain>
    </DataRow>
  );
}
